import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthenticationService} from '../../../authentication.service';
import {DialogOptions} from '../../../common/dialog-options';
import {WfmModalComponent as modalComponent} from '../../../components/wfm-modal/wfm-modal.component';
import {Features} from '../../../models/plan';

export const EXTERNAL_FORECAST_NOT_AVAILABLE_KEY = "external.forecast.not.available";

/**
 * Shows an OK-only message dialog; the result settles when it is closed. Opened on the body so it stays up
 * while the caller navigates away from the External Forecast page.
 */
export function showExternalForecastMessage(modalService: NgbModal, titleKey: string, messageKey: string, msgType: "warn" | "error"): Promise<any> {
  const dgOption = new DialogOptions();
  dgOption.titleKey = titleKey;
  dgOption.messageKey = messageKey;
  dgOption.msgType = msgType;
  dgOption.showCancel = false;
  dgOption.confirmLabel = "btn.ok.label";
  dgOption.container = "body";
  return modalComponent.showModalMessage(dgOption, modalService);
}

/**
 * Convenience gate for /site-plans-v5/:id/external-forecast (AC-04). The server's feature gate is the
 * real control; this only avoids rendering the page and calling the endpoint when the toggle is off.
 */
export const externalForecastFeatureGuard: CanActivateFn = (route) => {
  if (inject(AuthenticationService).hasFeature(Features.EXTERNAL_FORECAST)) {
    return true;
  }
  const planId = route.parent?.paramMap.get("id") ?? route.paramMap.get("id");
  showExternalForecastMessage(inject(NgbModal), "external.forecast.title", EXTERNAL_FORECAST_NOT_AVAILABLE_KEY, "warn")
    .catch(() => undefined);
  return inject(Router).createUrlTree(["/site-plans-v5", planId]);
};
